import React from 'react';
import { Link } from 'gatsby';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/index.scss';
import Layout from '../components/layout'
import Header from '../components/header'
import Footer from '../components/footer'
import logo from '../images/logo.png'
import stairs from '../images/stairs.jpg'
import family from '../images/family.jpg'
import bar from '../images/bar.jpg'
import shoe from '../images/shoe.jpg'
import food from '../images/food.jpg'
import '../components/slider';
import Slider from '../components/slider';
import Coaches from '../components/coaches';
import Schedule from '../components/scheduleComponent';
import ShowCaseCarousel from '../components/carousel';
import ShowcaseSlider from '../components/showcaseSlider';
import "react-transition-group";
import "react-popper";



const IndexPage = () => (
  <>
    <Header color='#707070' />
    {/* <!-- Showcase --> */}
      <section id="showcaseIndex" className="pt-5">
        {/* <img src={triangle1} className="triangle1 slide-in"/> */}
        {/* <img src={triangle2} className="triangle2 slide-in"/> */}
        <ShowcaseSlider/>
    </section>
    {/* CFD Section */}
    <section id="cfd" className="container">
        <div className="letter-card">
            <h2 className="teko">C</h2>
            <div className="decorative-line"></div>
            <h3 className="teko">COMMUNITY</h3>
            <p>Here at Crossfit Deliverance community is super important to us. We have been told many time that when people first move here this is where they make their first friends in the area. Being around other people with similiar goals really helps out in your fitness journey.</p>
        </div>
        <div className="letter-card">
            <h2 className="teko">F</h2>
            <div className="decorative-line"></div>
            <h3 className="teko">FITNESS</h3>
            <p>Here at CrossFit Deliverance we don’t just want you to be fit, we want you to have “FUN” while doing it. If you’re having fun, you’ll keep coming. If you keep coming, you’ll get results. If you get results, you’ll have fun! The loop keeps on going.</p>
        </div>
        <div className="letter-card">
            <h2 className="teko">D</h2>
            <div className="decorative-line"></div>
            <h3 className="teko">DEDICATION</h3>
            <p>Here at CrossFit Deliverance we are dedicated to your goal and we want you to be as well. We want and expect everyone to develop grit and tenacity through a positive mindset and dedication to the process. If you stay dedicated, you will reach your goal!</p>
        </div>
    
    </section>

    {/* About Section */}
    <section id="about-container">
        <section id="about-story">
        <div className="about-grid py-5">
            <div className="text">
                <h2 className="teko">OUR STORY</h2>
                <h3 className="teko">Standing on the Shoulders of Giants</h3>
                <p>The owners believe that there is greatness in everyone, but most individuals never get the chance to find that greatness. “Support” & “Dedication” are the key words. Most people never get the support from their family, friends or community and thus never stay dedicated. Amy & James received support to be at the amazing place they are and they want to pass that forward! They see CrossFit Deliverance as the “Giant”, the “Support” that you never had, a rock that you can find strength in, consistency in, success in. They are Dedicated to you! Once you find that success then you too can become a “Giant” that your Family, Friends and Community can stand on.</p>
            
            </div> 
            <div className="photo">
                <img src={family} className="family-photo"/>
            </div>
            
        </div>
        </section>
    </section>
    <section className="classes">
        <div className="container">
            <h2 className="teko">CROSSFIT</h2>
            <p className="secondary-header">SERVICES</p>
            <div className="decorative-line"></div>
            <div className="classCard my-3 py-5">
                <div className="classText">
                    <h3 className="teko">GROUP CLASSES</h3>
                    <br/>
                    <p>Group classes are lead by one of our amazing coaches. Classes are great for people of all ages and skill levels, because work outs are written in a way in which they can be scaled to fit individual needs.</p>
                    <br/>
                    <Link to="/crossfit"className="primary-button-small px-5">LEARN MORE</Link>
                </div>
                <div className="photo1 photo">
                </div>
            </div>
            <div className="classCard my-3 py-5">
                <div className="classText">
                    <h3 className="teko">PERSONAL TRAINING</h3>
                    <br/>
                    <p>1-ON-1 training is a great way to reach your fitness goals fast. One on one coaching personalized to your need is a sure fire way to make progress.</p>
                    <br/>
                    <Link to="/training"className="primary-button-small px-5">LEARN MORE</Link>
                </div>
                <div className="photo2 photo">
                    {/* <img src={shoe}/> */}
                </div>
            </div>
            <div className="classCard my-3 py-5">
                <div className="classText">
                    <h3 className="teko">NUTRITION</h3>
                    <br/>
                    <p>Nutrition is the foundation of your health. Don't let all your hard work in the gym be for nothing! Learn to eat right, and have a coach help keep you accountable.</p>
                    <br/>
                    <Link to="/nutrition"className="primary-button-small px-5">LEARN MORE</Link>
                </div>
                <div className="photo3 photo">
                    {/* <img src={food}/> */}
                </div>
            </div>
            <div className="classCard my-3 py-5">
                <div className="classText">
                    <h3 className="teko">ACCELERATOR COURSES</h3>
                    <br/>
                    <p>Accelerator Courses are a great way to improve your abilities in specific movements in a group setting faster then in a normal CrossFit class. All courses are 4-12 weeks long and meet 1-3 days a week. Expect home work and to work hard.</p>
                    <br/>
                    <Link to="/seminars" className="primary-button-small px-5">LEARN MORE</Link>
                </div>
                <div className="photo4 photo">
                    {/* <img src={stairs}/> */}
                </div>
            </div>
        </div>
    </section>
    <Coaches />
    {/* <Slider /> */}
    <Footer/>
  </>
)


export default IndexPage
